export const LIST_TYPE_CRYSTAL = 'list-type-crystal';
export const LIST_TYPE_TOOTH = 'list-type-tooth';
